import {
  SET_SCHOOL,
  ADD_NEW_SUGGESTION,
  EDIT_SUGGESTION,
  SET_SUGGESTIONS,
  CLEAN_NEW_SUGGESTIONS,
  UPDATE_SCHOOL_INVITE,
  UPDATE_SCHOOL_DETAILS,
} from 'store/mutation-types';
import Vue from 'vue';
import { DELETE_SUGGESTION } from '../../mutation-types';

export default {
  [SET_SCHOOL](state, school) {
    state.currentSchool = school;
    return state;
  },
  [UPDATE_SCHOOL_INVITE](state, updatedKeys) {
    if (updatedKeys) {
      const updated_invite = Object.assign({}, state.currentSchool.invites[0], updatedKeys);
      Vue.set(state.currentSchool.invites, 0, updated_invite);
    }
    return state;
  },
  [SET_SUGGESTIONS](state, suggestions) {
    state.suggestions = suggestions;
    return state;
  },
  [UPDATE_SCHOOL_DETAILS](state, updatedKeys) {
    if (updatedKeys) {
      const updated_record = Object.assign({}, state.currentSchool, updatedKeys);
      Vue.set(state, 'currentSchool', updated_record);
    }
    return state;
  },
  [ADD_NEW_SUGGESTION](state, suggestion) {
    if (!suggestion.is_draft) {
      suggestion.isNew = true;
    }
    state.suggestions.unshift(suggestion);
    return state;
  },
  [EDIT_SUGGESTION](state, suggestion) {
    const index = state.suggestions.findIndex(s => s.id === suggestion.id);
    if (!suggestion.is_draft) {
      suggestion.isNew = true;
    }
    if (index > -1) {
      Vue.set(state.suggestions, index, suggestion);
    }
    return state;
  },
  [DELETE_SUGGESTION](state, suggestion) {
    const index = state.suggestions.findIndex(s => s.id === suggestion.id);
    if (index > -1) {
      state.suggestions.splice(index, 1);
    }
    return state;
  },
  [CLEAN_NEW_SUGGESTIONS](state) {
    state.suggestions.forEach((suggestion) => (suggestion.isNew = false));
    return state;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/adminPortal/mutations.js